export default __webpack_public_path__ + "static/media/img_2.2d7f2bdf.png";